export default "__VITE_ASSET__DCyRIsM2__"